//```import constants types
import {
    REPORTS_OVERVIEW_LOAD_DATA,
    REPORTS_OVERVIEW_LOAD_DATA_RESULT,
    REPORTS_OVERVIEW_EXECUTE,
    REPORTS_OVERVIEW_EXECUTE_RESULT,
    REPORTS_OVERVIEW_EXPORT,
    REPORTS_OVERVIEW_EXPORT_RESULT,
} from 'Redux/actionTypes';


export const reportsOverviewGetData = (id, reportKey) => ({
    type: REPORTS_OVERVIEW_LOAD_DATA,
    payload: { id, reportKey }
});

export const reportsOverviewGetDataResult = (data) => ({
    type: REPORTS_OVERVIEW_LOAD_DATA_RESULT,
    payload: data
});

export const executeReport = (reportId, values, limit, nextToken = null, oldNextToken = null) => ({
    type: REPORTS_OVERVIEW_EXECUTE,
    payload: { reportId, values, limit, nextToken, oldNextToken }
});

export const executeReportResult = (data, error, oldNextToken = null) => ({
    type: REPORTS_OVERVIEW_EXECUTE_RESULT,
    payload: { result: data, error, oldNextToken }
});

export const exportReport = (reportId, values, format, reportProperties, timeZone, lang, messages, reportName, limit) => ({
    type: REPORTS_OVERVIEW_EXPORT,
    payload: { reportId, values, format, reportProperties, timeZone, lang, messages, reportName, limit }
});

export const exportReportResult = (data, error) => ({
    type: REPORTS_OVERVIEW_EXPORT_RESULT,
    payload: { result: data, error }
});